import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/app.scss'
import VueCurrencyFilter from 'vue-currency-filter'
import 'leaflet/dist/leaflet.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vueHeadful from 'vue-headful'

library.add(faFilePdf)

Vue.component('vue-headful', vueHeadful);

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(VueCurrencyFilter,
    {
        symbol : '€',
        thousandsSeparator: '.',
        fractionCount: 0,
        fractionSeparator: ',',
        symbolPosition: 'front',
        symbolSpacing: true
    })

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
